<template>
    <footer>
        <div class="center-content" style="text-align:center;">
            <ul>
                <li>
                    <a href="https://www.essilorusa.com/privacy-policy" target="_blank">Privacy Policy</a>
                </li>
                <li>
                    <a href="https://www.essilorusa.com/ca-privacy-rights" target="_blank">California Privacy Rights</a>
                </li>
                <li>
                    <a href="https://www.essilorusa.com/terms-of-use" target="_blank">Terms of Use</a>
                </li>
                <li>
                    <a href="https://www.essilorluxottica.com/en/governance/ethics-and-compliance" target="_blank">Ethics & Compliance</a>
                </li>
            </ul>
            <div class="clear"></div>
            <div class="footer-padding">
                <div class="facts"> ©2023 Essilor of America, Inc. Unless indicated otherwise, all trademarks are the property of Essilor International and/or its subsidiaries in the United States and in other countries.</div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {

}
</script>
<style>
.pad-before-footer {
    margin-bottom: 10px;
}

footer {
    clear: both;
    padding-top: 30px;
    background: #00f;
    padding-bottom: 60px
}

footer .footer-padding {
    margin-right: 15%;
    margin-left: 15%;
    text-align: center;
}

footer ul li {
    margin: 10px
}

@media only screen and (min-width:768px) {
    footer ul {
        text-align: center
    }
}

footer li {
    display: inline-block;
    height: 22px;
    margin: 25px;
    text-align: center
}

footer li a {
    font-family: "Noto Sans";
    font-style: normal;
    font-weight: 400;
    color: white;
    font-size: 13px;
    text-decoration: none
}

@media only screen and (min-width:640px) {
    footer li a {
        font-size: 16px
    }
}

@media only screen and (min-width:768px) {
    footer li a {
        font-size: 13px
    }
}

footer .facts {
    font-family: "Noto Sans";
    font-style: normal;
    color: #FFF;
    font-size: 10px;
    line-height: 20px;
    margin-bottom: 23px
}
</style>